import React from "react";
import { Stack, Box, Typography, Grid } from "@mui/material";

const arrService = [
  {
    desc: "serviceContentDescribe1",
    pic: "/images/warehouse-custom-formality1.jpg",
  },
  { desc: "serviceContentDescribe2", pic: "/images/cargo2.png" },
  { desc: "serviceContentDescribe3", pic: "/images/tax.jpg" },
  { desc: "serviceContentDescribe4", pic: "/images/transport2.png" },
];

export const ServiceContentTwo = ({ translate }) => {
  return (
    <Box>
      <Box sx={{ marginBottom: "30px" }}>
        <Box>
          <Typography variant="h5" gutterBottom>
            <b>{translate("serviceContentHead2")}</b>
          </Typography>
        </Box>
      </Box>
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent={{ xs: "start", md: "space-evenly" }}
        alignItems={{ xs: "center", md: "start" }}
      >
        <Grid container rowSpacing={1} columnSpacing={1}>
          {arrService.map((service) => {
            return (
              <Grid item xs={12} md={6} lg={3} key={service.desc} my={1}>
                <Box sx={{ textAlign: "center" }}>
                  <img
                    src={service.pic}
                    alt={service.desc}
                    width={220}
                    height={250}
                  />
                </Box>
                <Typography align="center">
                  <b>{translate(service.desc)}</b>
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </Box>
  );
};
